var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.editors)?_c('v-text-field',_vm._g(_vm._b({staticClass:"editor",attrs:{"autocomplete":"off"}},'v-text-field',_vm.$attrs,false),_vm.$listeners)):_c('v-text-field',_vm._g(_vm._b({attrs:{"filled":"","autocomplete":"off"}},'v-text-field',_vm.$attrs,false),_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }